import CountingAdd from '../Counting/CountingAdd/CountingAdd'
import { useContext } from 'react'
import { CompaniesContext } from 'stores/CompaiesContext'
import {useCountings} from 'hooks/useCountings/useCountings'
import {
    Button,
    Box,
    Card,
    CardBody,
    CardHeader, Checkbox,
    Heading,
    HStack,
    Table,
    TableCaption,
    TableContainer,
    Tbody,
    Th,
    Thead,
    Tr,
    Select,
    Input
} from '@chakra-ui/react'
import { CountingRow } from './CountingsTable/CountingRow'
import {DeleteCountings} from './CountingsTable/DeleteCountings/DeleteCountings'
import Pagination from '../Pagination/Pagination'
import useAuthStore from '../../stores/authStore'
import { Filters } from './Filters'
import { CalendarViewSwitcher } from './CalendarViewSwitcher/CalendarViewSwitcher'
import { CountingsCalendar } from './CountingsCalendar/CountingsCalendar'


const Countings = () => {
   const {countings, fetchCountings, handleChangeCompany, handleChangeStoreId,
       selectedCompanyId, selectedStoreId, handleSubmit, stores, setSelectedStoreId,
       setSelectedCompanyId, setSelectedCompany, selectedDate, handleDateChange, managers,
       handleSelectCounting, handleDeleteCountings, isDeleting, handlePageChange, filters, setFilters, selectedManagerId, setSelectedManagerId, settings, setSettings,
       isCalendarView, setIsCalendarView, calendarDate, setCalendarDate, calendarView, setCalendarView} = useCountings()
       const user = useAuthStore((state) => state.user)

    const { companies } = useContext(CompaniesContext)

    const handleFilterChange = (newFilter) => {
        setFilters (newFilter)
        handlePageChange(1)
    }

    return (
        <Box
            height={isCalendarView ? '100%' : undefined}
            display={isCalendarView ? 'flex' : undefined}
            flexDirection='column'
        >
            <CountingAdd
                companies={companies}
                fetchCountings={fetchCountings}
                handleChangeCompany={handleChangeCompany}
                handleChangeStoreId={handleChangeStoreId}
                handleSubmit={handleSubmit}
                selectedCompanyId={selectedCompanyId}
                selectedStoreId={selectedStoreId}
                stores={stores}
                setSelectedStoreId={setSelectedStoreId}
                setSelectedCompanyId={setSelectedCompanyId}
                setSelectedCompany={setSelectedCompany}
                selectedDate={selectedDate}
                handleDateChange={handleDateChange}
                managers={managers}
                setSelectedManagerId={setSelectedManagerId}
                selectedManagerId={selectedManagerId}
                settings={settings}
                setSettings={setSettings}

            />
            <Card m={2} flex={isCalendarView ? 1 : undefined} minHeight={isCalendarView ? '400px' : undefined}>
            <CardHeader flexShrink={0}>
                <HStack spacing={4}>
                    <Heading size='md'> Countings </Heading>
                    <CalendarViewSwitcher
                        isCalendarView={isCalendarView}
                        setIsCalendarView={setIsCalendarView}
                    />
                </HStack>
                <Box my='6'>
                    

                </Box>
            </CardHeader>
            <CardBody
                display={isCalendarView ? 'flex' : undefined}
                flexDirection='column'
                minHeight={0}
            >
                {isCalendarView ? (
                 <CountingsCalendar
                    countings={countings}
                    date={calendarDate}
                    view={calendarView}
                    onNavigate={setCalendarDate}
                    onView={setCalendarView}
                 />
                  ) :  (      
                  <TableContainer>
                    <Table variant='striped'>
                        <TableCaption>List of the Countings</TableCaption>
                        <Thead>
                            <Tr>
                                <Filters 
                                    companies={companies}
                                    extraFilters={{ managers }}
                                    //shops={countings?.shops} 
                                    handleInputChange={fetchCountings}
                                    filters={filters}
                                    setFilters={handleFilterChange}
                                />
                            </Tr>  
                            <Tr>
                                <Th>

                                </Th>
                                <Th>Date</Th>
                                <Th>Company</Th>
                                <Th>Shop</Th>
                                <Th>Branch</Th>
                                <Th>Manager</Th>
                                <Th>Amount</Th>
                                <Th>Missing</Th>
                                <Th>Double</Th>
                                <Th>
                                    {(user?.is_admin || user?.is_counting_manager) &&(
                                        <DeleteCountings handleDeleteCountings={handleDeleteCountings} isDeleting={isDeleting}/>
                                    )}
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {countings?.data?.map(counting => (
                                <CountingRow
                                    key={counting._id}
                                    //fetchCountings={fetchCountings}
                                    counting={counting}
                                    managers={managers}
                                    managerSelected={counting?.manager_id}
                                    handleSelectCounting={handleSelectCounting}
                                />
                            ))}
                        </Tbody>
                    </Table>
                    <Pagination key={JSON.stringify(filters)} lastPage={countings.last_page ?? 1} getData={handlePageChange} />
                </TableContainer>
                )}
            </CardBody>
        </Card>
        </Box>
    )
}

export default Countings
